import { Component, Input } from '@angular/core';
import { BlogArticleDetail } from 'src/app/services/rest-api/rest-api';

@Component({
  selector: 'libero-desktop-newest-blog-article-preview',
  templateUrl: './desktop-newest-blog-article-preview.component.html',
  styleUrls: ['./desktop-newest-blog-article-preview.component.scss'],
  standalone: false
})
export class DesktopNewestBlogArticlePreviewComponent {
  @Input() public articlePreview!: BlogArticleDetail;
}
